import MapView from '@arcgis/core/views/MapView';
import { GeometricType } from '../types/geo';

export interface TypedMapView extends MapView {
  fulcrumGeometryTypes?: GeometricType[];
}

export const allGeometryTypes: GeometricType[] = ['Point', 'MultiPoint', 'LineString', 'MultiLineString', 'Polygon', 'MultiPolygon'];

export const setSupportedGeometryTypes = (mapView: MapView, types: GeometricType[]) => {
  mapView?.set('fulcrumGeometryTypes', types);
};

export const supportedGeometryTypes = (
  mapView: TypedMapView, defaultTypes?: GeometricType[],
) => mapView?.fulcrumGeometryTypes ?? defaultTypes ?? allGeometryTypes;
